// Import routes
import ROUTES, { RenderRoutes } from './navigation/routes';

const App = () => {
  return <RenderRoutes routes={ROUTES} />;
};

export default App;
